<script>
  // import Swiper core and required modules
  import { Swiper, SwiperSlide } from "swiper/svelte";
  import { Navigation, Pagination, Scrollbar, A11y, Autoplay } from "swiper";
  import { Router, Link, Route, link, navigate } from "svelte-routing";
  import { onMount } from "svelte";
  // Import Swiper styles
  import "swiper/css";
  import "swiper/css/navigation";
  import "swiper/css/pagination";
  import "swiper/css/scrollbar";

  const API_END_POINT = END_POINT;
  const api_url = API_END_POINT + "types.php";
  const categories_api_url = API_END_POINT + "category.php";
  const size_api_url = API_END_POINT + "size.php";
  const color_api_url = API_END_POINT + "colors.php";
  const fetch_eight_api_url = API_END_POINT + "fetchfilter.php";

  const next = document.getElementById("next");
  const previous = document.getElementById("previous");

  let types = [];
  let categories = [];
  let sizes = [];
  let colors = [];
  let ten_products = [];
  let path;
  let page_previous;
  let page_next;
  let shop_set;
  let firstproduct;
  let lastproduct;

  let isfilter_open,
    product_type,
    page,
    selectedcategory,
    selectedsize,
    selectedcolor = "";

  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  // console.log("path : " + path);

  onMount(() => {
    window.scrollTo(0, 0);
    const user = localStorage.getItem("us");

    if (user === null || user === "") {
      navigate("/login");
    } else {
      page = urlParams.get("page");
      selectedcategory = urlParams.get("category");
      selectedsize = urlParams.get("size");
      selectedcolor = urlParams.get("color");

      if (page === undefined || page === "" || page === null) {
        page = 0;
      }
      shop_set = page;

      // console.log(page);
      fetchproducts(page, selectedcategory, selectedsize, selectedcolor);
    }
  });

  function gonextpage() {
    var currentpage_id = urlParams.get("page");
    if (currentpage_id === 0) {
      page_next = 1;
    } else if (currentpage_id === 1) {
      page_next = Number(currentpage_id) + 1;
    } else {
      page_next = Number(currentpage_id) + 1;
    }

    let currentpage = window.location.href;
    var href = new URL(currentpage);
    href.searchParams.set("page", page_next);
    window.location.href = href;
  }

  function gopreviouspage() {
    var currentpage_id = urlParams.get("page");
    if (currentpage_id === 0) {
      page_previous = "";
    } else if (currentpage_id === 1) {
      page_previous = "0";
    } else {
      page_previous = Number(currentpage_id) - 1;
    }

    let currentpage = window.location.href;
    var href = new URL(currentpage);
    href.searchParams.set("page", page_previous);
    window.location.href = href;
  }

  // console.log(page_previous);
  // console.log(page_next);

  async function fetchproducts(i, j, k, l) {
    const page_id = i;
    const page_category = j;
    const page_size = k;
    const page_color = l;
    const pathfromurl = window.location.pathname;
    let paths = pathfromurl.split("/");
    product_type = paths[3];
    // console.log("product_type : " + product_type);

    const response = await fetch(api_url);
    const data = await response.json();
    types = data;

    const category_response = await fetch(categories_api_url, {
      method: "POST",
      body: JSON.stringify({
        product_type: product_type,
      }),
    });
    const category_response_data = await category_response.json();
    categories = category_response_data;

    const size_response = await fetch(size_api_url);
    const size_response_data = await size_response.json();
    sizes = size_response_data;

    const colors_response = await fetch(color_api_url);
    const colors_response_data = await colors_response.json();
    colors = colors_response_data;

    const posts_response = await fetch(fetch_eight_api_url, {
      method: "POST",
      body: JSON.stringify({
        page: page_id,
        product_type: product_type,
        page_category: page_category,
        page_size: page_size,
        page_color: page_color,
      }),
    });
    const posts_response_data = await posts_response.json();
    ten_products = posts_response_data;

    firstproduct = ten_products[0];
    lastproduct = ten_products[9];

    // console.log(firstproduct);
    // console.log(lastproduct);

    if (
      lastproduct == null ||
      (lastproduct == "") | (lastproduct == undefined)
    ) {
      // console.log(lastproduct);
      document.getElementById("next").style.display = "none";
    }
  }

  function unhidefilter(i) {
    if (i == false) {
      var filterid = document.getElementById("shop-filter-menu");
      // console.log(i);
      filterid.style.display = "block";
      isfilter_open = true;
    } else if (i == true) {
      var filterid = document.getElementById("shop-filter-menu");
      // console.log(i);
      filterid.style.display = "none";
      isfilter_open = false;
    } else {
      var filterid = document.getElementById("shop-filter-menu");
      // console.log(i);
      filterid.style.display = "block";
      isfilter_open = true;
    }
  }

  function remove_placeholder() {
    const nodeList = document.querySelectorAll(".placeholder");
    for (var i = 0; i < nodeList.length; i++) {
      nodeList[i].classList.remove("placeholder");
    }
  }
</script>

<svelte:head>
  <title>Shop Page</title>
</svelte:head>

<main class="main-wrapper">
  <!-- ...:::Start User Event Section:::... -->
  <div class="header-section">
    <div class="container">
      <!-- Start User Event Area -->
      <div class="header-area">
        <div class="header-top-area header-top-area--style-1">
          <ul class="event-list">
            <li class="list-item">
              <Link
                to="./"
                area-label="mobile menu offcanvas svg icon"
                class="btn btn--size-33-33 btn--center btn--round btn--color-radical-red btn--bg-white btn--box-shadow main-menu offcanvas-toggle offside-menu"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  class="bi bi-house-fill"
                  viewBox="0 0 16 16"
                >
                  <path
                    fill-rule="evenodd"
                    d="m8 3.293 6 6V13.5a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 2 13.5V9.293l6-6zm5-.793V6l-2-2V2.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5z"
                  />
                  <path
                    fill-rule="evenodd"
                    d="M7.293 1.5a1 1 0 0 1 1.414 0l6.647 6.646a.5.5 0 0 1-.708.708L8 2.207 1.354 8.854a.5.5 0 1 1-.708-.708L7.293 1.5z"
                  />
                </svg>
              </Link>
            </li>
            <li class="list-item">
              <h6 class="title text-center">{decodeURI(product_type)}</h6>
            </li>
            <li class="list-item">
              <ul class="list-child">
                <li class="list-item">
                  <span class="notch-bg" />
                  <Link
                    to="cart"
                    area-label="Cart"
                    class="btn btn--size-33-33 btn--center btn--round btn--color-radical-red btn--bg-white btn--box-shadow"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      class="bi bi-cart-fill"
                      viewBox="0 0 16 16"
                    >
                      <path
                        d="M0 1.5A.5.5 0 0 1 .5 1H2a.5.5 0 0 1 .485.379L2.89 3H14.5a.5.5 0 0 1 .491.592l-1.5 8A.5.5 0 0 1 13 12H4a.5.5 0 0 1-.491-.408L2.01 3.607 1.61 2H.5a.5.5 0 0 1-.5-.5zM5 12a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm7 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm-7 1a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm7 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"
                      />
                    </svg>
                  </Link>
                </li>
                <li class="list-item">
                  <span class="notch-bg" />
                  <Link
                    to="settings"
                    area-label="Cart"
                    class="btn btn--size-33-33 btn--center btn--round btn--color-radical-red btn--bg-white btn--box-shadow"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      class="bi bi-person-fill"
                      viewBox="0 0 16 16"
                    >
                      <path
                        d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H3zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"
                      />
                    </svg>
                  </Link>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
      <!-- End User Event Area -->
    </div>
  </div>
  <!-- ...:::End User Event Section:::... -->

  <div class="catagories-section section-gap-top-25">
    <div class="container">
      <div class="catagories-area">
        <div class="catagories-nav-2">
          <!-- Slider main container -->
          <!-- Additional required wrapper -->
          <Swiper
            spaceBetween={10}
            slidesPerView={4}
          >
            {#if types != ""}
              {#each types as product_types}
                <!-- Slides -->
                <SwiperSlide class="swiper-slide w-auto p-2">
                  <a href="/shop/filter/{product_types}?page=0" class="btn2 p-2"
                    >{product_types}</a
                  >
                </SwiperSlide>
              {/each}
            {/if}
          </Swiper>
        </div>
      </div>
    </div>
  </div>

  <div class="search-n-filter-section section-gap-top-25">
    <div class="container">
      <!-- Start Search & Filter Area -->
      <div class="search-n-filter-area">
        <button
          id="filter-trigger"
          aria-label="Filter Icon"
          class="load-more-btn"
          on:click={unhidefilter(isfilter_open)}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            class="bi bi-funnel-fill"
            viewBox="0 0 16 16"
            ><path
              d="M1.5 1.5A.5.5 0 0 1 2 1h12a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.128.334L10 8.692V13.5a.5.5 0 0 1-.342.474l-3 1A.5.5 0 0 1 6 14.5V8.692L1.628 3.834A.5.5 0 0 1 1.5 3.5v-2z"
            /></svg
          > Filter
        </button>
      </div>
      <!-- End Search & Filter Area -->

      <div class="shop-filter shadow-drop-center" id="shop-filter-menu">
        <div class="container">
          <div class="row">
            <div class="col-12">
              <form action="" method="GET">
                <ul class="product-variable-lists">
                  <li class="list-item">
                    <div class="left text-pink">Type</div>
                    <div class="right">
                      <select
                        id="category"
                        name="category"
                        class="form-select form-select-sm"
                      >
                        <option value="">Select a Category</option>
                        {#each categories as catagorie}
                          <option value={catagorie}>{catagorie}</option>
                        {/each}
                      </select>
                    </div>
                  </li>
                  <li class="list-item">
                    <div class="left text-pink">Size</div>
                    <div class="right">
                      <ul class="size-chart inner-child-item">
                        <select
                          id="size"
                          name="size"
                          class="form-select form-select-sm"
                        >
                          <option value="">Select a Size</option>
                          {#each sizes as size}
                            <option value={size}>{size}</option>
                          {/each}
                        </select>
                        <!-- {#each sizes as size}
                          <li>
                            <label for={size}>
                              <input
                                type="radio"
                                name="size"
                                id={size}
                                value={size}
                                checked=""
                              />
                              <span class="size-text">{size}</span>
                            </label>
                          </li>
                        {/each} -->
                      </ul>
                    </div>
                  </li>
                  <li class="list-item">
                    <div class="left text-pink">Color</div>
                    <div class="right">
                      <select
                        id="color"
                        name="color"
                        class="form-select form-select-sm"
                      >
                        <option value="">Select a color</option>
                        {#each colors as color}
                          <option value={color}>{color}</option>
                        {/each}
                      </select>
                    </div>
                  </li>
                </ul>
                <div class="shop-filter-block">
                  <button class="load-more-btn" type="submit">APPLY</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- ...:::Start Catagories - 1 Section:::... -->
  <div class="catagories-section section-gap-top-50">
    <div class="container">
      <div class="catagories-wrapper catagories-shop-wrapper">
        {#if firstproduct !== null}
          <div class="catagories-wrapper-content">
            <!-- Start Product Single Item -->
            {#each ten_products as post}
              {#if post != null}
                <div
                  class="single-product-item product-item--style-3 placeholder-glow"
                  style="max-height: 270px;"
                >
                  <a href="/product/{post.no}">
                    <picture>
                      <source
                        srcset="https://imagecdn.veeranfashions.com/webp/{post.image.replace(
                          'png',
                          'webp'
                        )}"
                        type="image/webp"
                        alt="product"
                      />
                      <source
                        srcset="https://imagecdn.veeranfashions.com/{post.image}"
                        type="image/png"
                      />
                      <img
                        class="placeholder img-max-height rounded"
                        src="https://imagecdn.veeranfashions.com/{post.image}"
                        alt="product"
                        on:load={remove_placeholder}
                      />
                    </picture>
                  </a>
                  <div class="content">
                    <div class="content--left">
                      <p class="title ellipsis">
                        <Link to="/product/{post.no}" class="text-secondary"
                          >{post.name}</Link
                        >
                      </p>
                      <br />
                      <span class="text-colored fw-bolder"
                        >&#8377 <del class="fw-normal text-secondary"
                          >{post.original_price}</del
                        >
                        {post.price}</span
                      >
                    </div>
                    <div class="content--right" hidden>
                      <a
                        href="wishlist"
                        aria-label="Wishlist"
                        class="btn btn--size-33-33 btn--center btn--round btn--color-pink-swan btn--bg-white btn--box-shadow"
                        ><i class="icon icon-carce-heart" /></a
                      >
                    </div>
                  </div>
                </div>
              {/if}
            {/each}
            <!-- ENd Product Single Item -->
          </div>
        {:else}
          <h2 class="center pb-5">No Products to show</h2>
        {/if}
        {#if shop_set == "0"}
          <button class="load-more-btn" id="next" on:click={gonextpage}
            >Next</button
          >
        {:else}
          <button class="load-more-btn" id="next" on:click={gonextpage}
            >Next</button
          >
          <button
            class="load-more-btn"
            id="previous"
            on:click={() => {
              history.back();
            }}>Previous</button
          >
        {/if}
      </div>
    </div>
  </div>
  <!-- ...:::Start Catagories - 1 Section:::... -->

  <!-- ...:::Start User Event Section:::... -->
  <div class="user-event-section">
    <!-- Start User Event Area -->
    <div class="col pos-relative">
      <div class="user-event-area">
        <div class="nav">
          <Link to="/" class="nav__link">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              fill="currentColor"
              class="bi bi-house-fill"
              viewBox="0 0 16 16"
            >
              <path
                fill-rule="evenodd"
                d="m8 3.293 6 6V13.5a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 2 13.5V9.293l6-6zm5-.793V6l-2-2V2.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5z"
              />
              <path
                fill-rule="evenodd"
                d="M7.293 1.5a1 1 0 0 1 1.414 0l6.647 6.646a.5.5 0 0 1-.708.708L8 2.207 1.354 8.854a.5.5 0 1 1-.708-.708L7.293 1.5z"
              />
            </svg>
            <br />
            <h6>Home</h6>
          </Link>
          <Link to="/wishlist" class="nav__link">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              fill="currentColor"
              class="bi bi-heart-fill"
              viewBox="0 0 16 16"
              ><path
                fill-rule="evenodd"
                d="M8 1.314C12.438-3.248 23.534 4.735 8 15-7.534 4.736 3.562-3.248 8 1.314z"
              /></svg
            >
            <br />
            <h6>Wishlist</h6>
          </Link>
          <Link to="/shop" class="nav__link">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              fill="currentColor"
              class="bi bi-grid-fill"
              viewBox="0 0 16 16"
            >
              <path
                d="M1 2.5A1.5 1.5 0 0 1 2.5 1h3A1.5 1.5 0 0 1 7 2.5v3A1.5 1.5 0 0 1 5.5 7h-3A1.5 1.5 0 0 1 1 5.5v-3zm8 0A1.5 1.5 0 0 1 10.5 1h3A1.5 1.5 0 0 1 15 2.5v3A1.5 1.5 0 0 1 13.5 7h-3A1.5 1.5 0 0 1 9 5.5v-3zm-8 8A1.5 1.5 0 0 1 2.5 9h3A1.5 1.5 0 0 1 7 10.5v3A1.5 1.5 0 0 1 5.5 15h-3A1.5 1.5 0 0 1 1 13.5v-3zm8 0A1.5 1.5 0 0 1 10.5 9h3a1.5 1.5 0 0 1 1.5 1.5v3a1.5 1.5 0 0 1-1.5 1.5h-3A1.5 1.5 0 0 1 9 13.5v-3z"
              />
            </svg>
            <br />
            <h6>Shop</h6>
          </Link>

          
          <Link to="/orders" class="nav__link">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              fill="currentColor"
              class="bi bi-box-seam-fill"
              viewBox="0 0 16 16"
            >
              <path
                fill-rule="evenodd"
                d="M15.528 2.973a.75.75 0 0 1 .472.696v8.662a.75.75 0 0 1-.472.696l-7.25 2.9a.75.75 0 0 1-.557 0l-7.25-2.9A.75.75 0 0 1 0 12.331V3.669a.75.75 0 0 1 .471-.696L7.443.184l.01-.003.268-.108a.75.75 0 0 1 .558 0l.269.108.01.003 6.97 2.789ZM10.404 2 4.25 4.461 1.846 3.5 1 3.839v.4l6.5 2.6v7.922l.5.2.5-.2V6.84l6.5-2.6v-.4l-.846-.339L8 5.961 5.596 5l6.154-2.461L10.404 2Z"
              />
            </svg>
            <br />
            <h6>Orders</h6>
          </Link>

          <Link to="/settings" class="nav__link">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              fill="currentColor"
              class="bi bi-gear-fill"
              viewBox="0 0 16 16"
            >
              <path
                d="M9.405 1.05c-.413-1.4-2.397-1.4-2.81 0l-.1.34a1.464 1.464 0 0 1-2.105.872l-.31-.17c-1.283-.698-2.686.705-1.987 1.987l.169.311c.446.82.023 1.841-.872 2.105l-.34.1c-1.4.413-1.4 2.397 0 2.81l.34.1a1.464 1.464 0 0 1 .872 2.105l-.17.31c-.698 1.283.705 2.686 1.987 1.987l.311-.169a1.464 1.464 0 0 1 2.105.872l.1.34c.413 1.4 2.397 1.4 2.81 0l.1-.34a1.464 1.464 0 0 1 2.105-.872l.31.17c1.283.698 2.686-.705 1.987-1.987l-.169-.311a1.464 1.464 0 0 1 .872-2.105l.34-.1c1.4-.413 1.4-2.397 0-2.81l-.34-.1a1.464 1.464 0 0 1-.872-2.105l.17-.31c.698-1.283-.705-2.686-1.987-1.987l-.311.169a1.464 1.464 0 0 1-2.105-.872l-.1-.34zM8 10.93a2.929 2.929 0 1 1 0-5.86 2.929 2.929 0 0 1 0 5.858z"
              />
            </svg>
            <br />
            <h6>Settings</h6>
          </Link>
        </div>
      </div>
    </div>
    <!-- End User Event Area -->
  </div>
  <!-- ...:::End User Event Section:::... -->

  <footer class="footer-section" />
</main>
